import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  emptyServiceOrderAmountTotals,
  formatServiceOrderAmount,
  ServiceOrderAmountTotals,
  sumSelectedServiceOrderAmounts,
} from '../service-order-amount-totals';

@Component({
  selector: 'app-service-orders-totalizers',
  templateUrl: './service-orders-totalizers.component.html',
  styleUrls: ['./service-orders-totalizers.component.sass'],
})
export class ServiceOrdersTotalizersComponent implements OnInit {
  @Input()
  totalizers: {
    selectTotal: number;
    totalCreated: number;
    pending: number;
    approved: number;
    inProgress: number;
    concluded: number;
    canceled: number;
    rejected: number;
    inAnalising: number;
    myServiceOrders: number;
  } = {
      selectTotal: 0,
      totalCreated: 0,
      pending: 0,
      approved: 0,
      inProgress: 0,
      concluded: 0,
      canceled: 0,
      rejected: 0,
      inAnalising: 0,
      myServiceOrders: 0
    };

  @Input()
  amounts: ServiceOrderAmountTotals = emptyServiceOrderAmountTotals();

  @Input()
  length: number;

  @Input()
  initialActiveStatus: string | null = null;

  @Output() statusFilterChange = new EventEmitter<string>();

  @Input() selection: any;

  activeStatus: string | null = null;

  constructor() { }

  ngOnInit(): void {
    // Define o status ativo inicial, se fornecido
    if (this.initialActiveStatus) {
      this.activeStatus = this.initialActiveStatus;
    }
  }

  filterByStatus(status: string): void {
    this.activeStatus = status;
    console.log(`Totalizador clicado: ${status}`);
    console.log(`Emitindo evento statusFilterChange com valor: ${status}`);
    this.statusFilterChange.emit(status);
  }

  isActive(status: string): boolean {
    return this.activeStatus === status;
  }

  getSelectedCount(): number {
    if (this.selection?.selectAll) return this.totalizers.selectTotal;
    if (this.selection) {
      return this.selection.items.length;
    }
    return 0;
  }

  getSelectedAmount(): number {
    if (this.selection?.selectAll) return this.amounts?.selectTotal || 0;
    return sumSelectedServiceOrderAmounts(this.selection?.items);
  }

  formatAmount(value: number): string {
    return formatServiceOrderAmount(value);
  }
}
